export default {"src":"/_next/static/media/banzai_logo_rgb_white.280bbe7b.svg","height":96,"width":402,"blurWidth":0,"blurHeight":0};